import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  footer: {
    padding: theme.spacing(2, 0),
    backgroundColor: theme.palette.gray.main,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  info: {
    color: 'white',
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      fontSize: 10,
    },
  },
  icon: {
    marginLeft: theme.spacing(2),
    width: 30,
  },
  fb: {
    color: '#8b9dc3',
  },
  ig: {
    color: '#c1558b',
  },
  social: {
    width: 30,
    height: 30,
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
}));
